import CatinnoPNG from '../../../assets/images/partners/catinno.webp';
import DimaNordPNG from '../../../assets/images/partners/dima_nord.webp';
import JaesPNG from '../../../assets/images/partners/jaes.webp';
import LcpPNG from '../../../assets/images/partners/lcp.webp';
import Nt2ePNG from '../../../assets/images/partners/nt2e.webp';
import PeacePNG from '../../../assets/images/partners/peace.webp';
import TeaSarlPNG from '../../../assets/images/partners/teasarl.webp';
import AquaproxPNG from '../../../assets/images/partners/aquaprox.webp';
import CasamerchantsPNG from '../../../assets/images/partners/casamerchants.webp';

export interface Partner {
  name: string;
  image: string;
  url?: string;
}

// Create partners array with all available partners
export const partners: Partner[] = [
  {
    name: 'Catinno',
    image: CatinnoPNG,
    url: 'https://catinno.com'
  },
  {
    name: 'Dima Nord',
    image: DimaNordPNG,
    url: 'https://dimanord.ma'
  },
  {
    name: 'JAES',
    image: JaesPNG,
    url: 'https://jaescompany.com/?lang=fr'
  },
  {
    name: 'LCP industrie',
    image: LcpPNG,
    url: 'https://www.facebook.com/people/Lcp-Industrie/100063989142553/'
  },
  {
    name: 'NT2E',
    image: Nt2ePNG,
    url: 'https://nt2e.com'
  },
  {
    name: 'Peace SARL',
    image: PeacePNG,
    url: 'https://www.facebook.com/people/PEACE-Sarl/100064028883867/'
  },
  {
    name: 'Tea SARL',
    image: TeaSarlPNG,
    url: 'https://tea-sarl.com/'
  },
  {
    name: 'Aquaprox',
    image: AquaproxPNG,
    url: 'https://aquaprox.com/'
  },
  {
    name: 'Casamerchants',
    image: CasamerchantsPNG,
    url: 'https://www.casamerchants.com/'
  }
];
